"use client";

import { useContext } from "react";
import { DialogsContext } from "@/lib/context/dialogs.context";

export function useDialogs() {
  const context = useContext(DialogsContext);

  if (!context) {
    throw new Error(
      "useDialogs must be used within DialogsProvider. " +
        "Make sure DialogsProvider wraps your component.",
    );
  }

  return context;
}
